import React, { useState, useEffect, useCallback } from 'react';
import { Dialog } from 'primereact/dialog';

const ChangePasswordDialog = ({ isOpen, onHide, user, toast }) => {
    const [passData, setPassData] = useState({ oldPass: '', newPass: '', confirmPass: '' });
    const [isDesktop, setIsDesktop] = useState(true);

    const [showOldPass, setShowOldPass] = useState(false);
    const [showNewPass, setShowNewPass] = useState(false);
    const [showConfirmPass, setShowConfirmPass] = useState(false);

    useEffect(() => {
        const handleResize = () => setIsDesktop(window.innerWidth > 992);
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const resetForm = () => {
        setPassData({ oldPass: '', newPass: '', confirmPass: '' });
        setShowOldPass(false);
        setShowNewPass(false);
        setShowConfirmPass(false);
    };

    const getAuthHeaders = useCallback(() => {
        return {
            'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
            'Content-Type': 'application/json'
        };
    }, []);

    const handleLogout = useCallback(() => {
        toast.current?.show({ severity: 'error', summary: 'Lỗi xác thực', detail: 'Phiên đăng nhập hết hạn hoặc không hợp lệ!', life: 3000 });
        setTimeout(() => {
            localStorage.removeItem('user');
            localStorage.removeItem('accessToken');
            window.location.href = '/login';
        }, 1500);
    }, [toast]);

    const handleSubmit = async () => {
        if (!passData.oldPass || !passData.newPass || !passData.confirmPass) {
            toast.current?.show({ severity: 'warn', detail: 'Vui lòng điền đầy đủ các trường!' });
            return;
        }

        if (passData.newPass !== passData.confirmPass) {
            toast.current?.show({ severity: 'error', detail: 'Mật khẩu xác nhận không khớp!' });
            return;
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/changepassword`, {
                method: 'POST',
                headers: getAuthHeaders(),
                body: JSON.stringify({
                    UserId: user.Id,
                    OldPassword: passData.oldPass,
                    NewPassword: passData.newPass
                })
            });

            if (response.status === 401 || response.status === 403) {
                handleLogout();
                return;
            }

            let result;
            try { result = await response.json(); } catch (err) { result = {}; }

            if (response.ok && result.status !== 'error') {
                toast.current?.show({ severity: 'success', detail: 'Đổi mật khẩu thành công!' });
                resetForm();
                onHide();
            } else {
                toast.current?.show({ severity: 'error', detail: result.message || 'Đổi mật khẩu thất bại!' });
            }
        } catch (e) {
            toast.current?.show({ severity: 'error', detail: 'Lỗi kết nối máy chủ!' });
        }
    };

    const inputWrapperStyle = { position: 'relative', marginTop: '5px' };
    const inputStyle = {
        width: '100%',
        padding: '10px',
        border: '1px solid #ccc',
        borderRadius: '4px',
        boxSizing: 'border-box',
        paddingRight: '40px'
    };
    const iconStyle = {
        position: 'absolute',
        right: '12px',
        top: '50%',
        transform: 'translateY(-50%)',
        cursor: 'pointer',
        color: '#666'
    };

    return (
        <Dialog
            header="Đổi mật khẩu"
            visible={isOpen}
            style={{ width: isDesktop ? '450px' : '95vw', maxWidth: '100%' }}
            onHide={() => { onHide(); resetForm(); }}
            footer={
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                    <button className="btn-cancel-modal" onClick={() => { onHide(); resetForm(); }}>Hủy</button>
                    <button className="btn-save-modal" onClick={handleSubmit}>Hoàn tất</button>
                </div>
            }
        >
            <p style={{ fontSize: '13px', color: '#666', marginBottom: '20px' }}>Điền vào biểu mẫu dưới đây để đổi mật khẩu</p>

            <div className="form-group-password">
                <label style={{ fontWeight: 'bold', color: '#333' }}>Mật khẩu cũ *</label>
                <div style={inputWrapperStyle}>
                    <input
                        type={showOldPass ? "text" : "password"}
                        style={inputStyle}
                        value={passData.oldPass}
                        onChange={(e) => setPassData({ ...passData, oldPass: e.target.value })}
                    />
                    <i className={`fa-solid ${showOldPass ? 'fa-eye-slash' : 'fa-eye'}`}
                        style={iconStyle}
                        onClick={() => setShowOldPass(!showOldPass)}></i>
                </div>

                <label style={{ marginTop: '15px', display: 'block', fontWeight: 'bold', color: '#333' }}>Mật khẩu mới *</label>
                <div style={inputWrapperStyle}>
                    <input
                        type={showNewPass ? "text" : "password"}
                        style={inputStyle}
                        value={passData.newPass}
                        onChange={(e) => setPassData({ ...passData, newPass: e.target.value })}
                    />
                    <i className={`fa-solid ${showNewPass ? 'fa-eye-slash' : 'fa-eye'}`}
                        style={iconStyle}
                        onClick={() => setShowNewPass(!showNewPass)}></i>
                </div>

                <label style={{ marginTop: '15px', display: 'block', fontWeight: 'bold', color: '#333' }}>Xác nhận mật khẩu mới *</label>
                <div style={inputWrapperStyle}>
                    <input
                        type={showConfirmPass ? "text" : "password"}
                        style={inputStyle}
                        value={passData.confirmPass}
                        onChange={(e) => setPassData({ ...passData, confirmPass: e.target.value })}
                    />
                    <i className={`fa-solid ${showConfirmPass ? 'fa-eye-slash' : 'fa-eye'}`}
                        style={iconStyle}
                        onClick={() => setShowConfirmPass(!showConfirmPass)}></i>
                </div>
            </div>
        </Dialog>
    );
};

export default ChangePasswordDialog;